import React from 'react';
import classNames from 'classnames';
import Icon from '../../common/components/Icon';
import {
	PrimaryButton,
	SecondaryButton,
	FlatPrimaryButton,
	FlatSecondaryButton
} from '../';

const Dialog = ({ title, iconName, children, footer }) => {
	return (
		<div className="dialog-wrapper">
			<div className="dialog">
				<header className="dialog__header">
					<Icon className="dialog__header-icon" icon={iconName} />
					<span className="dialog__header-title">{title}</span>
				</header>
				<div className="dialog__content">{children}</div>
				<div className="dialog__footer">{footer}</div>
			</div>
		</div>
	);
};

const ConfirmationDialog = ({ message, confirmText, onConfirm, onCancel }) => {
	const footer = (
		<div className="dialog__footer-btn">
			<div className="btn-left">
				<FlatSecondaryButton onClick={onCancel}>
					Annuler
				</FlatSecondaryButton>
			</div>
			<FlatPrimaryButton onClick={onConfirm}>
				{confirmText}
			</FlatPrimaryButton>
		</div>
	);
	return (
		<Dialog title="Confirmation" iconName="circle-bin" footer={footer}>
			{message}
		</Dialog>
	);
};

const ErrorDialog = ({ message, onCancel }) => {
	const footer = (
		<div>
			<FlatPrimaryButton>Ok</FlatPrimaryButton>
		</div>
	);
	return (
		<Dialog
			title="Oups, une erreur s'est produite"
			iconName="cancel"
			footer={footer}
		>
			{props.children}
		</Dialog>
	);
};

export { ErrorDialog, ConfirmationDialog };



// WEBPACK FOOTER //
// ./src/js/Ui/Dialog/Dialog.jsx